/* ManTire Atelier — collection filtering, sorting, grid density and load more */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  const root = () => $('[data-collection-section]');

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('[data-facets-form]');
      this.onChange = debounce(() => this.submit(), 350);
      this.form.addEventListener('change', (e) => { if (e.target.matches('[data-range-min], [data-range-max]')) return; this.syncSort(e.target); this.onChange(); });
      // The toolbar's Sort by sits outside the form (form="…"), so its change never reaches the form's own listener.
      if (!this.sortBound) {
        this.sortBound = true;
        document.addEventListener('change', (e) => {
          const t = e.target;
          if (t.name === 'sort_by' && t.form === this.form && !this.form.contains(t)) { this.syncSort(t); this.onChange(); }
        });
      }
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-facets-close]')) this.close();
        const more = e.target.closest('[data-show-more]');
        if (more) { const list = more.previousElementSibling; list.classList.toggle('is-expanded'); more.hidden = true; }
        const clear = e.target.closest('[data-facets-clear]');
        if (clear) { e.preventDefault(); FacetFilters.render(clear.getAttribute('href')); }
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    }
    // Keep the toolbar and filter-panel Sort by on the same choice, whichever was used
    syncSort(el) {
      if (el.name !== 'sort_by') return;
      $$('select[name="sort_by"]').forEach((s) => { if (s !== el && s.form === this.form) s.value = el.value; });
    }
    open() { this.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    close() { if (!this.classList.contains('is-open')) return; this.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    submit() {
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '' && k !== 'sort_by') params.append(k, v); }
      const sort = fd.get('sort_by');
      if (sort) params.set('sort_by', sort);
      FacetFilters.render(`${location.pathname}?${params.toString()}`);
    }
    static async render(url, { push = true } = {}) {
      const r = root(); if (!r) return;
      const facets = $('facet-filters', r);
      const sectionId = facets ? facets.dataset.sectionId : r.dataset.sectionId;
      const u = new URL(url, location.origin);
      u.searchParams.delete('page');
      const fetchUrl = new URL(u);
      fetchUrl.searchParams.set('section_id', sectionId);
      r.classList.add('is-loading');
      const openStates = facets ? $$('details.facet', facets).map((d) => d.open) : [];
      try {
        const html = await (await fetch(fetchUrl)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-collection-section]');
        if (!fresh) return;
        const swap = (sel) => { const a = $(sel, r); const b = $(sel, fresh); if (a && b) a.innerHTML = b.innerHTML; };
        swap('.collection__main');
        swap('.facets__body');
        swap('.facets__foot');
        if (facets) $$('details.facet', facets).forEach((d, i) => { if (openStates[i] !== undefined) d.open = openStates[i] || d.open; });
        const about = $('.collection-about', r);
        if (push) history.pushState({ facets: true }, '', u.pathname + u.search);
        initGrid();
        const top = $('[data-toolbar]', r);
        if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (about) about.hidden = u.search.length > 1 && u.search !== '?';
        document.dispatchEvent(new CustomEvent('facets:rendered', { detail: { url: u.pathname + u.search } }));
      } finally { r.classList.remove('is-loading'); }
    }
  }
  customElements.define('facet-filters', FacetFilters);

  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.max = Number(this.dataset.max) || 10000;
      this.rMin = this.querySelector('[data-range-min]');
      this.rMax = this.querySelector('[data-range-max]');
      this.iMin = this.querySelector('[data-input-min]');
      this.iMax = this.querySelector('[data-input-max]');
      const fire = debounce(() => this.iMax.dispatchEvent(new Event('change', { bubbles: true })), 450);
      const fromRange = () => {
        let a = Number(this.rMin.value); let b = Number(this.rMax.value);
        if (a > b - 50) { if (document.activeElement === this.rMin) a = b - 50; else b = a + 50; }
        this.rMin.value = a; this.rMax.value = b;
        this.iMin.value = a > 0 ? a : '';
        this.iMax.value = b < this.max ? b : '';
        this.paint(); fire();
      };
      this.rMin.addEventListener('input', fromRange);
      this.rMax.addEventListener('input', fromRange);
      [this.iMin, this.iMax].forEach((i) => i.addEventListener('input', () => { this.rMin.value = this.iMin.value || 0; this.rMax.value = this.iMax.value || this.max; this.paint(); }));
      this.paint();
    }
    paint() {
      const s = this.querySelector('.price-range__slider');
      s.style.setProperty('--from', `${(Number(this.rMin.value) / this.max) * 100}%`);
      s.style.setProperty('--to', `${(Number(this.rMax.value) / this.max) * 100}%`);
    }
  }
  customElements.define('price-range', PriceRange);

  const GRID_KEY = 'mantire_grid';
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  function initGrid() {
    const r = root(); if (!r) return;
    const grid = $('[data-product-grid]', r);
    if (!grid) return;
    const mobile = isMobile();
    let n = null;
    try { n = localStorage.getItem(GRID_KEY + (mobile ? '_m' : '')); } catch {}
    if (n) grid.style.setProperty(mobile ? '--cols-mobile' : '--cols', n);
    const cur = (n || getComputedStyle(grid).getPropertyValue(mobile ? '--cols-mobile' : '--cols')).trim();
    $$('[data-grid]', r).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.grid === cur)));
  }
  document.addEventListener('click', async (e) => {
    const r = root(); if (!r) return;
    const gridBtn = e.target.closest('[data-grid]');
    if (gridBtn && r.contains(gridBtn)) {
      try { localStorage.setItem(GRID_KEY + (isMobile() ? '_m' : ''), gridBtn.dataset.grid); } catch {}
      initGrid();
      return;
    }
    const open = e.target.closest('[data-facets-open]');
    if (open) { const f = $('facet-filters', r); f && f.open(); return; }
    const link = e.target.closest('[data-facet-link]');
    if (link && r.contains(link)) { e.preventDefault(); FacetFilters.render(link.getAttribute('href')); return; }
    // Card-price order: every fabric is already on the page, so Load more shows the next ones
    const reveal = e.target.closest('[data-reveal-more]');
    if (reveal && r.contains(reveal)) {
      const step = Number(reveal.dataset.revealMore) || 24;
      const later = $$('[data-product-grid] > template[data-later]', r);
      later.slice(0, step).forEach((t, i) => {
        const li = t.content.firstElementChild;
        if (li) { li.classList.add('is-new'); li.style.animationDelay = `${Math.min(i, 8) * 40}ms`; }
        t.replaceWith(t.content);
      });
      const count = $('[data-load-count]', r);
      if (count) {
        const shown = Number(count.dataset.offset || 0) + $$('[data-product-grid] > [data-item]', r).length;
        count.textContent = count.dataset.template.replace('[shown]', shown.toLocaleString('en-IN'));
        const bar = $('.load-more__bar > span', r); if (bar) bar.style.setProperty('--p', `${Math.round((shown * 100) / Number(count.dataset.total || shown))}%`);
      }
      if (later.length <= step) { reveal.hidden = true; const nextPage = $('[data-load-next]', r); if (nextPage) nextPage.hidden = false; }
      return;
    }
    const next = e.target.closest('[data-load-next]');
    if (next && r.contains(next)) {
      e.preventDefault();
      next.classList.add('is-loading');
      const u = new URL(next.href, location.origin);
      const facets = $('facet-filters', r);
      u.searchParams.set('section_id', facets ? facets.dataset.sectionId : r.dataset.sectionId);
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
        const items = $$('[data-product-grid] > [data-item]', doc);
        const grid = $('[data-product-grid]', r);
        items.forEach((li, i) => { li.classList.add('is-new'); li.style.animationDelay = `${Math.min(i, 8) * 40}ms`; grid.appendChild(li); });
        const freshLoad = $('[data-load-more]', doc);
        const curLoad = $('[data-load-more]', r);
        if (freshLoad && curLoad) curLoad.innerHTML = freshLoad.innerHTML;
        const freshPag = $('.pagination', doc); const curPag = $('.pagination', r);
        if (freshPag && curPag) curPag.innerHTML = freshPag.innerHTML;
        const clean = new URL(next.href, location.origin);
        history.replaceState({}, '', clean.pathname + clean.search);
      } finally { next.classList.remove('is-loading'); }
    }
  });

  window.addEventListener('popstate', () => { if (root()) FacetFilters.render(location.href, { push: false }); });
  initGrid();
})();
